/** @jsx jsx */

import { jsx } from '@emotion/react';
import Button from '@atlaskit/button/custom-theme-button';
import CrossCircleIcon from '@atlaskit/icon/glyph/cross-circle';
import { N500 } from '@atlaskit/theme/colors';
import { deleteEmojiLabel } from '../../util/constants';
import { emojiDeleteButton, deleteButton } from './styles';

/**
 * Test id for wrapper Emoji delete button
 */
export var RENDER_EMOJI_DELETE_BUTTON_TESTID = 'render-emoji-delete-button';
var DeleteButton = function DeleteButton(props) {
  return jsx("span", {
    css: deleteButton,
    className: emojiDeleteButton,
    "data-testid": RENDER_EMOJI_DELETE_BUTTON_TESTID
  }, jsx(Button, {
    iconBefore: jsx(CrossCircleIcon, {
      label: deleteEmojiLabel,
      primaryColor: "var(--ds-text-subtle, ".concat(N500, ")"),
      size: "small"
    }),
    onClick: props.onClick,
    appearance: "subtle-link",
    spacing: "none",
    testId: "emoji-delete-button",
    tabIndex: -1
  }));
};
export default DeleteButton;